import { render } from "./DockIcon.vue?vue&type=template&id=01fd93a1&scoped=true"
import script from "./DockIcon.vue?vue&type=script&lang=js"
export * from "./DockIcon.vue?vue&type=script&lang=js"

import "./DockIcon.vue?vue&type=style&index=0&id=01fd93a1&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fd93a1"]])

export default __exports__